import React from "react"
import CustomMarkdown from "components/atoms/CustomMarkdown"
import { useLang } from "hooks/useLang"
import { EventDetailsSection, IFinalEvent } from "types/event"
import FadeOutEffect from "components/atoms/FadeOutEffect"

interface IProps {
    event: IFinalEvent
}

const EventDescription = ({ event }: IProps) => {
    const { multiLangVars } = useLang()

    const renderSection = (
        key: number,
        title: string | undefined,
        content: string | undefined
    ) => (
        <div className="mb-6 last:mb-0" id="event-description" key={key}>
            <CustomMarkdown
                title={title}
                content={content || ""}
                className="text-white text-[14px] md:text-[20px] leading-relaxed"
            />
        </div>
    )
    return (
        <FadeOutEffect fadeStartAt={200} fadeHeight={50}>
            <div className="">
                {event?.details_sections?.length ? (
                    event.details_sections.map(
                        (section: EventDetailsSection, index) =>
                            renderSection(
                                index,
                                section?.[
                                    multiLangVars("title") as
                                        | "en_title"
                                        | "ar_title"
                                ],
                                section?.[
                                    multiLangVars("content") as
                                        | "en_content"
                                        | "ar_content"
                                ]
                            )
                    )
                ) : (
                    <div id="event-description">
                        <CustomMarkdown
                            className="text-white text-[14px] md:text-[20px] leading-relaxed"
                            content={
                                event?.[
                                    multiLangVars("description") as
                                        | "en_description"
                                        | "ar_description"
                                ] || ""
                            }
                        />
                    </div>
                )}
            </div>
        </FadeOutEffect>
    )
}

export default EventDescription
